import React, { useState, cloneElement } from "react";
import Button from "@material-ui/core/Button/Button";
import withStyles from "@material-ui/core/styles/withStyles";
import DrawerDisclosures from "../../../../components/Content/DrawerDisclosures";
import Dialog from "@material-ui/core/Dialog";
import { Slide } from "@material-ui/core";
import DialogTitle from "@material-ui/core/DialogTitle";
import IconButton from "@material-ui/core/IconButton";
import DialogContent from "@material-ui/core/DialogContent";
import { Close } from "@material-ui/icons";
import DialogActions from "@material-ui/core/DialogActions";
import SectionHeader from "../../../../components/UI/SectionHeader";

const styles = (theme) => ({
  paper: {
    width: "100%",
    height: "80%",
  },
  modalCloseBtn: {
    position: "absolute",
    top: 10,
    right: 10,
  },
});

const DisclosureModal = (props) => {
  const [open, setOpen] = useState(false);

  const handleOpenModal = () => {
    setOpen(true);
  };

  const handleCloseModal = () => {
    setOpen(false);
  };

  const { classes, dialogAnchorComponent } = props;

  if (!dialogAnchorComponent) {
    return null;
  }

  return (
    <React.Fragment>
      {cloneElement(dialogAnchorComponent, { onClick: handleOpenModal })}

      <Dialog
        open={open}
        TransitionComponent={Slide}
        TransitionProps={{ direction: "up" }}
        onClose={handleCloseModal}
        disableBackdropClick={true}
        disableEscapeKeyDown={true}
        aria-labelledby="disclosure-modal-title"
        maxWidth={"lg"}
        scroll={"paper"}
        classes={{ paper: classes.paper }}
      >
        <DialogTitle id="household-settings-modal-title" disableTypography>
          <SectionHeader text={"Disclosures"} />
          <IconButton
            className={classes.modalCloseBtn}
            aria-label="Close"
            onClick={handleCloseModal}
          >
            <Close color="primary" />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <DrawerDisclosures />
        </DialogContent>
        <DialogActions>
          <Button
            variant="contained"
            color="primary"
            onClick={handleCloseModal}
          >
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
};

export default withStyles(styles)(DisclosureModal);



// WEBPACK FOOTER //
// ./src/containers/Cy/components/DisclosureModal/index.jsx